import React from 'react'
import { observer } from 'mobx-react'
import { observable, computed } from 'mobx'
import isFunction from 'lodash/isFunction'
import RGL, { WidthProvider } from 'react-grid-layout'
import { merchProductContainer } from 'src/models'
import './styles.scss'

const ReactGridLayout = WidthProvider(RGL)

@observer
class ProductDragAndDrop extends React.Component {
  @observable cardHeight = this.props.cardHeight

  @computed
  get layout() {
    const { cols } = this.props
    return this.props.list.map((item, index) => {
      const x = index % cols
      const y = Math.floor(index / cols)
      return {
        x: x,
        y: y,
        w: 1,
        h: 1,
        minH: 1,
        maxH: 1,
        i: item.identifier || item.key,
      }
    })
  }

  componentDidMount() {
    this.props?.refineButtonRef?.current?.focus()
  }

  onLayoutChange = layout => {
    const { cols, saveLayout } = this.props
    if (isFunction(saveLayout)) {
      saveLayout(layout, cols)
    } else {
      merchProductContainer.productPositions = layout.map(data => {
        return {
          productId: data.i,
          x: data.x,
          y: data.y,
          position: data.y * cols + data.x + 1,
        }
      })
    }
  }

  handleSizeCalc = height => {
    if (height > this.cardHeight) {
      this.cardHeight = height
    }
  }

  renderItem = (listItem, index) => {
    const key = listItem.identifier || listItem.key

    const { cardHeight, additionalProps } = this.props
    // const x = index % cols
    // const y = Math.floor(index / cols)
    const height = this.cardHeight || cardHeight
    const props = {
      listItem,
      index,
      cardHeight: height,
      handleSizeCalc: this.handleSizeCalc,
      ...additionalProps,
    }

    return (
      <div
        className="drag-wrapper"
        key={key}
        // data-grid={{
        //   x: x,
        //   y: y,
        //   w: 1,
        //   h: 1,
        //   minH: 1,
        //   maxH: 1,
        // }}
      >
        <div
          className="productDrag"
          style={{ height: `${height}px` }}
          onLoad={this.props.handleSizeCalc}>
          {this.props.renderFunction(props)}
        </div>
      </div>
    )
  }

  render() {
    const {
      useDragAndDrop,
      cardHeight,
      cols,
      list,
      renderFunction,
      wrapper,
      additionalProps,
      compactType = 'horizontal',
    } = this.props

    if (!useDragAndDrop) {
      if (isFunction(wrapper)) {
        return wrapper(
          list.map((listItem, index) => {
            return renderFunction({ listItem, index, ...additionalProps })
          })
        )
      } else {
        return list.map((listItem, index) => {
          return renderFunction({ listItem, index, ...additionalProps })
        })
      }
    }

    const height = this.cardHeight || cardHeight
    return (
      <ReactGridLayout
        rowHeight={height}
        cols={cols}
        isResizable={false}
        width={100}
        layout={this.layout}
        isDraggable={true}
        compactType={compactType}
        onLayoutChange={this.onLayoutChange}
        draggableHandle=".productDrag"
        draggableCancel=".MyDragCancel"
        margin={[16, 8]}>
        {list.map(this.renderItem)}
      </ReactGridLayout>
    )
  }
}

export { ProductDragAndDrop }
